var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1109 26.6671C12.3382 26.6671 13.3331 25.6722 13.3331 24.4449C13.3331 23.2176 12.3382 22.2227 11.1109 22.2227C9.88359 22.2227 8.88867 23.2176 8.88867 24.4449C8.88867 25.6722 9.88359 26.6671 11.1109 26.6671Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6675 26.6671C23.8948 26.6671 24.8898 25.6722 24.8898 24.4449C24.8898 23.2176 23.8948 22.2227 22.6675 22.2227C21.4402 22.2227 20.4453 23.2176 20.4453 24.4449C20.4453 25.6722 21.4402 26.6671 22.6675 26.6671Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1118 20.4451H10.6673C10.222 20.4451 9.8451 20.1153 9.78643 19.6735L8.11176 7.11176H5.33398V5.33398H8.88954C9.33487 5.33398 9.71176 5.66376 9.77043 6.10554L10.2602 9.77843H25.7784C26.0593 9.77843 26.3242 9.91087 26.4913 10.1367C26.6593 10.3624 26.7109 10.654 26.63 10.9224L23.9633 19.8113C23.8504 20.1873 23.5038 20.4451 23.1118 20.4451Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.331aba0f54e55a70b1e4e1d8eb116cfc.svg";
export { ForwardRef as ReactComponent };